import { render, staticRenderFns } from "./BoardTestRecordPCBA.vue?vue&type=template&id=045431eb"
import script from "./BoardTestRecordPCBA.vue?vue&type=script&lang=js"
export * from "./BoardTestRecordPCBA.vue?vue&type=script&lang=js"
import style0 from "./BoardTestRecordPCBA.vue?vue&type=style&index=0&id=045431eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports